import { useState } from 'react';
import '@/App.css';
import RouteVisualization from './components/RouteVisualization';
import Header from './components/Header';

function App() {
  return (
    <div className="h-screen w-screen overflow-hidden flex flex-col bg-slate-50">
      <Header />
      <RouteVisualization />
    </div>
  );
}

export default App;
